<div class="">
  <div class="flex flex-col w-full">
    <div class="form-field-label">{{ label }}</div>
    <mat-form-field appearance="outline">
      <input
        matInput
        #detailInput
        [ngClass]="{ error: error }"
        placeholder="{{ placeholder }}"
        [(ngModel)]="editableValue"
        (ngModelChange)="validate()"
        (keyup.enter)="this.blur()"
        (keyup.esc)="this.revert()"
        saAutomatedSelector="{{ 'user-creation__' + label }}"
        (blur)="onBlur()"
        [disabled]="disabled"
      />
      <mat-error *ngIf="error">{{ error }}</mat-error>
    </mat-form-field>
  </div>
</div>
